// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActionsRow-module__font-s-10___BfEaD {
  font-size: 10px !important;
}

.ActionsRow-module__font-s-12___WMi9A {
  font-size: 12px !important;
}

.ActionsRow-module__font-s-13___VriGD {
  font-size: 13px !important;
}

.ActionsRow-module__font-s-14___d1W5A {
  font-size: 14px !important;
}

.ActionsRow-module__font-s-15___KQK5L {
  font-size: 15px !important;
}

.ActionsRow-module__font-s-16___d0fH2 {
  font-size: 16px !important;
}

.ActionsRow-module__font-s-18___sQAIQ {
  font-size: 18px !important;
}

.ActionsRow-module__font-s-20___c7oBi {
  font-size: 20px !important;
}

.ActionsRow-module__font-s-22___KSXWg {
  font-size: 22px !important;
}

.ActionsRow-module__font-s-28___kBPxE {
  font-size: 28px !important;
}

.ActionsRow-module__font-w-400___QwYtI {
  font-weight: 400 !important;
}

.ActionsRow-module__font-w-500___SUSAx {
  font-weight: 500 !important;
}

.ActionsRow-module__font-w-600___U51H1 {
  font-weight: 600 !important;
}

.ActionsRow-module__font-w-700___ts_Vi {
  font-weight: 700 !important;
}

.ActionsRow-module__p-5___xjnCQ {
  padding: 5px !important;
}

.ActionsRow-module__p-12___cGWnY {
  padding: 12px !important;
}

.ActionsRow-module__p-16___YxCKo {
  padding: 16px !important;
}

.ActionsRow-module__p-30___tVgdg {
  padding: 30px !important;
}

.ActionsRow-module__p-b-0___QRnja {
  padding-bottom: 0 !important;
}

.ActionsRow-module__p-b-5___FcFFA {
  padding-bottom: 5px !important;
}

.ActionsRow-module__p-b-10___oE_SF {
  padding-bottom: 10px !important;
}

.ActionsRow-module__p-b-12___rl8jN {
  padding-bottom: 12px !important;
}

.ActionsRow-module__p-b-16___XMtvb {
  padding-bottom: 16px !important;
}

.ActionsRow-module__p-b-18___f9O0o {
  padding-bottom: 18px !important;
}

.ActionsRow-module__p-b-20___rw27u {
  padding-bottom: 20px !important;
}

.ActionsRow-module__p-b-25___tujS7 {
  padding-bottom: 25px !important;
}

.ActionsRow-module__p-b-30___jaY3I {
  padding-bottom: 30px !important;
}

.ActionsRow-module__p-b-50___iICUc {
  padding-bottom: 50px !important;
}

.ActionsRow-module__p-t-0___RxOVi {
  padding-top: 0 !important;
}

.ActionsRow-module__p-t-12___rIYCN {
  padding-top: 12px !important;
}

.ActionsRow-module__p-t-16___a6joP {
  padding-top: 16px !important;
}

.ActionsRow-module__p-t-18___RlbIO {
  padding-top: 18px !important;
}

.ActionsRow-module__p-t-20___iMXDo {
  padding-top: 20px !important;
}

.ActionsRow-module__p-t-30___OX0I3 {
  padding-top: 30px !important;
}

.ActionsRow-module__p-t-40___MTRQm {
  padding-top: 40px !important;
}

.ActionsRow-module__p-t-50____3ysx {
  padding-top: 50px !important;
}

.ActionsRow-module__p-l-20___Vckxq {
  padding-left: 20px !important;
}

.ActionsRow-module__p-l-30___l50Vd {
  padding-left: 30px !important;
}

.ActionsRow-module__p-l-40___SjPkc {
  padding-left: 40px !important;
}

.ActionsRow-module__p-r-16___NVLQs {
  padding-right: 16px !important;
}

.ActionsRow-module__p-r-20___sAknC {
  padding-right: 20px !important;
}

.ActionsRow-module__p-r-30___sefvr {
  padding-right: 30px !important;
}

.ActionsRow-module__p-r-50___JPbHz {
  padding-right: 50px !important;
}

.ActionsRow-module__p-r-60___zLd_n {
  padding-right: 60px !important;
}

.ActionsRow-module__m-b-1___TG0l7 {
  margin-bottom: 1px !important;
}

.ActionsRow-module__m-b-2___ntUI9 {
  margin-bottom: 2px !important;
}

.ActionsRow-module__m-b-6___i4AZK {
  margin-bottom: 6px !important;
}

.ActionsRow-module__m-b-8___PHuuQ {
  margin-bottom: 8px !important;
}

.ActionsRow-module__m-b-10___Gg84t {
  margin-bottom: 10px !important;
}

.ActionsRow-module__m-b-14___SoFd1 {
  margin-bottom: 14px !important;
}

.ActionsRow-module__m-b-16___jk1Qh {
  margin-bottom: 16px !important;
}

.ActionsRow-module__m-b-20___rQoi7 {
  margin-bottom: 20px !important;
}

.ActionsRow-module__m-b-22___Mw09b {
  margin-bottom: 22px !important;
}

.ActionsRow-module__m-b-24___N_pUJ {
  margin-bottom: 24px !important;
}

.ActionsRow-module__m-b-30___vJgSF {
  margin-bottom: 30px !important;
}

.ActionsRow-module__m-b-32___php4C {
  margin-bottom: 32px !important;
}

.ActionsRow-module__m-b-40___o1oLK {
  margin-bottom: 40px !important;
}

.ActionsRow-module__m-t-2___XZBuh {
  margin-top: 2px !important;
}

.ActionsRow-module__m-t-3___moln2 {
  margin-top: 3px !important;
}

.ActionsRow-module__m-t-4___CI_0g {
  margin-top: 4px !important;
}

.ActionsRow-module__m-t-5___sgarV {
  margin-top: 5px !important;
}

.ActionsRow-module__m-t-8___B2rTZ {
  margin-top: 8px !important;
}

.ActionsRow-module__m-t-10___DGjaK {
  margin-top: 10px !important;
}

.ActionsRow-module__m-t-15___crs7g {
  margin-top: 15px !important;
}

.ActionsRow-module__m-t-16___qe_tP {
  margin-top: 16px !important;
}

.ActionsRow-module__m-t-20___dttu3 {
  margin-top: 20px !important;
}

.ActionsRow-module__m-t-22___mX0m3 {
  margin-top: 22px !important;
}

.ActionsRow-module__m-t-30___sp3et {
  margin-top: 30px !important;
}

.ActionsRow-module__m-t-32___q8vNn {
  margin-top: 32px !important;
}

.ActionsRow-module__m-l-auto___mbadO {
  margin-left: auto !important;
}

.ActionsRow-module__m-l-4___WxPdB {
  margin-left: 4px !important;
}

.ActionsRow-module__m-l-5___vWEFD {
  margin-left: 5px !important;
}

.ActionsRow-module__m-l-6___05n1c {
  margin-left: 6px !important;
}

.ActionsRow-module__m-l-8___eVes8 {
  margin-left: 8px !important;
}

.ActionsRow-module__m-l-10___wwIAz {
  margin-left: 10px !important;
}

.ActionsRow-module__m-l-16___pM4m9 {
  margin-left: 16px !important;
}

.ActionsRow-module__m-l-20___kpq3a {
  margin-left: 20px !important;
}

.ActionsRow-module__m-l-24___A_0ts {
  margin-left: 24px !important;
}

.ActionsRow-module__m-l-30___Guim3 {
  margin-left: 30px !important;
}

.ActionsRow-module__m-l-35___PoOLD {
  margin-left: 35px !important;
}

.ActionsRow-module__m-l-40___ukEMk {
  margin-left: 40px !important;
}

.ActionsRow-module__m-r-8___DzcmR {
  margin-right: 8px !important;
}

.ActionsRow-module__m-r-10___qh8Oc {
  margin-right: 10px !important;
}

.ActionsRow-module__m-r-16___M_7YK {
  margin-right: 16px !important;
}

.ActionsRow-module__m-r-20___eD06Z {
  margin-right: 20px !important;
}

.ActionsRow-module__m-r-24___rsXGB {
  margin-right: 24px !important;
}

.ActionsRow-module__m-r-30___y8jMr {
  margin-right: 30px !important;
}

.ActionsRow-module__m-r-40___YC9eQ {
  margin-right: 40px !important;
}

.ActionsRow-module__border-r-3___JzYul {
  border-radius: 3px !important;
}

.ActionsRow-module__border-r-4___Q29ZM {
  border-radius: 4px !important;
}

.ActionsRow-module__border-r-6___SA8_v {
  border-radius: 6px !important;
}

.ActionsRow-module__border-r-10___CKR6g {
  border-radius: 10px !important;
}

.ActionsRow-module__border-r-12___slKZh {
  border-radius: 12px !important;
}

.ActionsRow-module__border-r-16___GOSVk {
  border-radius: 16px !important;
}

.ActionsRow-module__border-r-50___h3GqZ {
  border-radius: 50% !important;
}

.ActionsRow-module__primary-border___KTOPD {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ActionsRow-module__primary-border-b___n_YTu {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ActionsRow-module__primary-border-t___WKkxy {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ActionsRow-module__primary-border-l___AzyBB {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ActionsRow-module__primary-border-r____wa4k {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ActionsRow-module__secondary-border___G_vdr {
  border: 1px solid #637768;
}

.ActionsRow-module__secondary-border-b___IoQyL {
  border-bottom: 1px solid #637768;
}

.ActionsRow-module__secondary-border-t___KZTmx {
  border-top: 1px solid #637768;
}

.ActionsRow-module__secondary-border-l___kJ75v {
  border-left: 1px solid #637768;
}

.ActionsRow-module__secondary-border-r___EsAMC {
  border-right: 1px solid #637768;
}

.ActionsRow-module__gap-0___c3gSE {
  gap: 0 !important;
}

.ActionsRow-module__gap-2___lYVtd {
  gap: 2px !important;
}

.ActionsRow-module__gap-4___yklqM {
  gap: 4px !important;
}

.ActionsRow-module__gap-5___bOWcZ {
  gap: 5px !important;
}

.ActionsRow-module__gap-6___yLNQi {
  gap: 6px !important;
}

.ActionsRow-module__gap-8___UltxV {
  gap: 8px !important;
}

.ActionsRow-module__gap-10___zky_6 {
  gap: 10px !important;
}

.ActionsRow-module__gap-12___VpILP {
  gap: 12px !important;
}

.ActionsRow-module__gap-14___hLAf4 {
  gap: 14px !important;
}

.ActionsRow-module__gap-16___kj10a {
  gap: 16px !important;
}

.ActionsRow-module__gap-18___Zbchv {
  gap: 18px !important;
}

.ActionsRow-module__gap-20___haIxC {
  gap: 20px !important;
}

.ActionsRow-module__gap-24___fc8Nv {
  gap: 24px !important;
}

.ActionsRow-module__gap-26___dhcZD {
  gap: 26px !important;
}

.ActionsRow-module__gap-30___uU19G {
  gap: 30px !important;
}

.ActionsRow-module__gap-32___BGxVM {
  gap: 32px !important;
}

.ActionsRow-module__gap-40___apisZ {
  gap: 40px !important;
}

.ActionsRow-module__gap-50___RqG1S {
  gap: 50px !important;
}

.ActionsRow-module__flex-1___u4Jjl {
  flex: 1;
}

.ActionsRow-module__flex-none___yZ4Qq {
  flex: none !important;
}

.ActionsRow-module__flex-column___e_zU_ {
  display: flex;
  flex-direction: column !important;
}

.ActionsRow-module__flex-row___UAuV7 {
  display: flex;
  flex-direction: row !important;
}

.ActionsRow-module__vertically-centered___eun6E {
  display: flex;
  align-items: center !important;
}

.ActionsRow-module__horizontally-centered___YeZUR {
  display: flex;
  justify-content: center !important;
}

.ActionsRow-module__horizontally-end___NM0CM {
  display: flex;
  justify-content: end !important;
}

.ActionsRow-module__vertically-start___DLeLq {
  display: flex;
  align-items: start !important;
}

.ActionsRow-module__space-between___PYCg7 {
  display: flex;
  justify-content: space-between !important;
}

.ActionsRow-module__flex-wrap___lKXPa {
  flex-wrap: wrap !important;
}

.ActionsRow-module__height-100___Awou3 {
  height: 100%;
}

.ActionsRow-module__width-50___YsHgj {
  width: 50% !important;
}

.ActionsRow-module__width-100___J3yJv {
  width: 100%;
}

.ActionsRow-module__cursor-pointer___Le3QW {
  cursor: pointer;
}

.ActionsRow-module__cursor-not-allowed___Lhso5 {
  cursor: not-allowed !important;
}

.ActionsRow-module__absolute-centered___BVla3 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ActionsRow-module__absolute___w9O0x {
  position: absolute;
}

.ActionsRow-module__relative___npnEG {
  position: relative;
}

.ActionsRow-module__fixed___Jpne1 {
  position: fixed;
}

.ActionsRow-module__visible___I1pCp {
  opacity: 1;
}

.ActionsRow-module__invisible___wREcW {
  opacity: 0;
}

.ActionsRow-module__col-90___D1mbb {
  width: 90% !important;
}

.ActionsRow-module__col-auto___JGSDw {
  width: auto !important;
}

.ActionsRow-module__medical-tabs___VEtMo {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ActionsRow-module__medical-table-new___eRXrx {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ActionsRow-module__medical-table-new___eRXrx:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ActionsRow-module__medical-table-new___eRXrx::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ActionsRow-module__medical-table-new___eRXrx::-webkit-scrollbar-track {
  display: none;
}
.ActionsRow-module__medical-table-new___eRXrx.ActionsRow-module__no-pagination___Uqlpi {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ActionsRow-module__medical-table-new___eRXrx.ActionsRow-module__no-pagination___Uqlpi:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ActionsRow-module__medical-table-new___eRXrx.ActionsRow-module__no-pagination___Uqlpi::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ActionsRow-module__medical-table-new___eRXrx.ActionsRow-module__no-pagination___Uqlpi::-webkit-scrollbar-track {
  display: none;
}

.ActionsRow-module__medical-table-empty___Vkq36 {
  padding: 14px 40px !important;
}

.ActionsRow-module__icon-btn___Vmk1P {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ActionsRow-module__search-icon___Lp0qC {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ActionsRow-module__disable-select___Qw6BP {
  user-select: none;
}

.ActionsRow-module__break-word___VPpnB {
  word-break: break-word;
}

.ActionsRow-module__popup-clear-btn___HL7nX {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ActionsRow-module__scroll-m-b-20___hA5hp {
  scroll-margin-bottom: 20px;
}

.ActionsRow-module__button___GYrvy {
  background-color: rgb(85, 86, 113);
  padding: 5px 18px;
  color: white;
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.4s ease;
}
.ActionsRow-module__button___GYrvy:hover {
  filter: brightness(90%);
}

.ActionsRow-module__loader___qWtf9 {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/DocumentationFragment/items/ActionsRow/ActionsRow.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kCAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;AA8pBF;AA5pBE;EACE,uBAAA;AA8pBJ;;AA1pBA;EACE,SAAA;AA6pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.button {\n  background-color: rgba(85, 86, 113);\n  padding: 5px 18px;\n  color: white;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: normal;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: opacity 0.4s ease;\n\n  &:hover {\n    filter: brightness(90%);\n  }\n}\n\n.loader {\n  margin: 0;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ActionsRow-module__font-s-10___BfEaD`,
	"fontS12": `ActionsRow-module__font-s-12___WMi9A`,
	"fontS13": `ActionsRow-module__font-s-13___VriGD`,
	"fontS14": `ActionsRow-module__font-s-14___d1W5A`,
	"fontS15": `ActionsRow-module__font-s-15___KQK5L`,
	"fontS16": `ActionsRow-module__font-s-16___d0fH2`,
	"fontS18": `ActionsRow-module__font-s-18___sQAIQ`,
	"fontS20": `ActionsRow-module__font-s-20___c7oBi`,
	"fontS22": `ActionsRow-module__font-s-22___KSXWg`,
	"fontS28": `ActionsRow-module__font-s-28___kBPxE`,
	"fontW400": `ActionsRow-module__font-w-400___QwYtI`,
	"fontW500": `ActionsRow-module__font-w-500___SUSAx`,
	"fontW600": `ActionsRow-module__font-w-600___U51H1`,
	"fontW700": `ActionsRow-module__font-w-700___ts_Vi`,
	"p5": `ActionsRow-module__p-5___xjnCQ`,
	"p12": `ActionsRow-module__p-12___cGWnY`,
	"p16": `ActionsRow-module__p-16___YxCKo`,
	"p30": `ActionsRow-module__p-30___tVgdg`,
	"pB0": `ActionsRow-module__p-b-0___QRnja`,
	"pB5": `ActionsRow-module__p-b-5___FcFFA`,
	"pB10": `ActionsRow-module__p-b-10___oE_SF`,
	"pB12": `ActionsRow-module__p-b-12___rl8jN`,
	"pB16": `ActionsRow-module__p-b-16___XMtvb`,
	"pB18": `ActionsRow-module__p-b-18___f9O0o`,
	"pB20": `ActionsRow-module__p-b-20___rw27u`,
	"pB25": `ActionsRow-module__p-b-25___tujS7`,
	"pB30": `ActionsRow-module__p-b-30___jaY3I`,
	"pB50": `ActionsRow-module__p-b-50___iICUc`,
	"pT0": `ActionsRow-module__p-t-0___RxOVi`,
	"pT12": `ActionsRow-module__p-t-12___rIYCN`,
	"pT16": `ActionsRow-module__p-t-16___a6joP`,
	"pT18": `ActionsRow-module__p-t-18___RlbIO`,
	"pT20": `ActionsRow-module__p-t-20___iMXDo`,
	"pT30": `ActionsRow-module__p-t-30___OX0I3`,
	"pT40": `ActionsRow-module__p-t-40___MTRQm`,
	"pT50": `ActionsRow-module__p-t-50____3ysx`,
	"pL20": `ActionsRow-module__p-l-20___Vckxq`,
	"pL30": `ActionsRow-module__p-l-30___l50Vd`,
	"pL40": `ActionsRow-module__p-l-40___SjPkc`,
	"pR16": `ActionsRow-module__p-r-16___NVLQs`,
	"pR20": `ActionsRow-module__p-r-20___sAknC`,
	"pR30": `ActionsRow-module__p-r-30___sefvr`,
	"pR50": `ActionsRow-module__p-r-50___JPbHz`,
	"pR60": `ActionsRow-module__p-r-60___zLd_n`,
	"mB1": `ActionsRow-module__m-b-1___TG0l7`,
	"mB2": `ActionsRow-module__m-b-2___ntUI9`,
	"mB6": `ActionsRow-module__m-b-6___i4AZK`,
	"mB8": `ActionsRow-module__m-b-8___PHuuQ`,
	"mB10": `ActionsRow-module__m-b-10___Gg84t`,
	"mB14": `ActionsRow-module__m-b-14___SoFd1`,
	"mB16": `ActionsRow-module__m-b-16___jk1Qh`,
	"mB20": `ActionsRow-module__m-b-20___rQoi7`,
	"mB22": `ActionsRow-module__m-b-22___Mw09b`,
	"mB24": `ActionsRow-module__m-b-24___N_pUJ`,
	"mB30": `ActionsRow-module__m-b-30___vJgSF`,
	"mB32": `ActionsRow-module__m-b-32___php4C`,
	"mB40": `ActionsRow-module__m-b-40___o1oLK`,
	"mT2": `ActionsRow-module__m-t-2___XZBuh`,
	"mT3": `ActionsRow-module__m-t-3___moln2`,
	"mT4": `ActionsRow-module__m-t-4___CI_0g`,
	"mT5": `ActionsRow-module__m-t-5___sgarV`,
	"mT8": `ActionsRow-module__m-t-8___B2rTZ`,
	"mT10": `ActionsRow-module__m-t-10___DGjaK`,
	"mT15": `ActionsRow-module__m-t-15___crs7g`,
	"mT16": `ActionsRow-module__m-t-16___qe_tP`,
	"mT20": `ActionsRow-module__m-t-20___dttu3`,
	"mT22": `ActionsRow-module__m-t-22___mX0m3`,
	"mT30": `ActionsRow-module__m-t-30___sp3et`,
	"mT32": `ActionsRow-module__m-t-32___q8vNn`,
	"mLAuto": `ActionsRow-module__m-l-auto___mbadO`,
	"mL4": `ActionsRow-module__m-l-4___WxPdB`,
	"mL5": `ActionsRow-module__m-l-5___vWEFD`,
	"mL6": `ActionsRow-module__m-l-6___05n1c`,
	"mL8": `ActionsRow-module__m-l-8___eVes8`,
	"mL10": `ActionsRow-module__m-l-10___wwIAz`,
	"mL16": `ActionsRow-module__m-l-16___pM4m9`,
	"mL20": `ActionsRow-module__m-l-20___kpq3a`,
	"mL24": `ActionsRow-module__m-l-24___A_0ts`,
	"mL30": `ActionsRow-module__m-l-30___Guim3`,
	"mL35": `ActionsRow-module__m-l-35___PoOLD`,
	"mL40": `ActionsRow-module__m-l-40___ukEMk`,
	"mR8": `ActionsRow-module__m-r-8___DzcmR`,
	"mR10": `ActionsRow-module__m-r-10___qh8Oc`,
	"mR16": `ActionsRow-module__m-r-16___M_7YK`,
	"mR20": `ActionsRow-module__m-r-20___eD06Z`,
	"mR24": `ActionsRow-module__m-r-24___rsXGB`,
	"mR30": `ActionsRow-module__m-r-30___y8jMr`,
	"mR40": `ActionsRow-module__m-r-40___YC9eQ`,
	"borderR3": `ActionsRow-module__border-r-3___JzYul`,
	"borderR4": `ActionsRow-module__border-r-4___Q29ZM`,
	"borderR6": `ActionsRow-module__border-r-6___SA8_v`,
	"borderR10": `ActionsRow-module__border-r-10___CKR6g`,
	"borderR12": `ActionsRow-module__border-r-12___slKZh`,
	"borderR16": `ActionsRow-module__border-r-16___GOSVk`,
	"borderR50": `ActionsRow-module__border-r-50___h3GqZ`,
	"primaryBorder": `ActionsRow-module__primary-border___KTOPD`,
	"primaryBorderB": `ActionsRow-module__primary-border-b___n_YTu`,
	"primaryBorderT": `ActionsRow-module__primary-border-t___WKkxy`,
	"primaryBorderL": `ActionsRow-module__primary-border-l___AzyBB`,
	"primaryBorderR": `ActionsRow-module__primary-border-r____wa4k`,
	"secondaryBorder": `ActionsRow-module__secondary-border___G_vdr`,
	"secondaryBorderB": `ActionsRow-module__secondary-border-b___IoQyL`,
	"secondaryBorderT": `ActionsRow-module__secondary-border-t___KZTmx`,
	"secondaryBorderL": `ActionsRow-module__secondary-border-l___kJ75v`,
	"secondaryBorderR": `ActionsRow-module__secondary-border-r___EsAMC`,
	"gap0": `ActionsRow-module__gap-0___c3gSE`,
	"gap2": `ActionsRow-module__gap-2___lYVtd`,
	"gap4": `ActionsRow-module__gap-4___yklqM`,
	"gap5": `ActionsRow-module__gap-5___bOWcZ`,
	"gap6": `ActionsRow-module__gap-6___yLNQi`,
	"gap8": `ActionsRow-module__gap-8___UltxV`,
	"gap10": `ActionsRow-module__gap-10___zky_6`,
	"gap12": `ActionsRow-module__gap-12___VpILP`,
	"gap14": `ActionsRow-module__gap-14___hLAf4`,
	"gap16": `ActionsRow-module__gap-16___kj10a`,
	"gap18": `ActionsRow-module__gap-18___Zbchv`,
	"gap20": `ActionsRow-module__gap-20___haIxC`,
	"gap24": `ActionsRow-module__gap-24___fc8Nv`,
	"gap26": `ActionsRow-module__gap-26___dhcZD`,
	"gap30": `ActionsRow-module__gap-30___uU19G`,
	"gap32": `ActionsRow-module__gap-32___BGxVM`,
	"gap40": `ActionsRow-module__gap-40___apisZ`,
	"gap50": `ActionsRow-module__gap-50___RqG1S`,
	"flex1": `ActionsRow-module__flex-1___u4Jjl`,
	"flexNone": `ActionsRow-module__flex-none___yZ4Qq`,
	"flexColumn": `ActionsRow-module__flex-column___e_zU_`,
	"flexRow": `ActionsRow-module__flex-row___UAuV7`,
	"verticallyCentered": `ActionsRow-module__vertically-centered___eun6E`,
	"horizontallyCentered": `ActionsRow-module__horizontally-centered___YeZUR`,
	"horizontallyEnd": `ActionsRow-module__horizontally-end___NM0CM`,
	"verticallyStart": `ActionsRow-module__vertically-start___DLeLq`,
	"spaceBetween": `ActionsRow-module__space-between___PYCg7`,
	"flexWrap": `ActionsRow-module__flex-wrap___lKXPa`,
	"height100": `ActionsRow-module__height-100___Awou3`,
	"width50": `ActionsRow-module__width-50___YsHgj`,
	"width100": `ActionsRow-module__width-100___J3yJv`,
	"cursorPointer": `ActionsRow-module__cursor-pointer___Le3QW`,
	"cursorNotAllowed": `ActionsRow-module__cursor-not-allowed___Lhso5`,
	"absoluteCentered": `ActionsRow-module__absolute-centered___BVla3`,
	"absolute": `ActionsRow-module__absolute___w9O0x`,
	"relative": `ActionsRow-module__relative___npnEG`,
	"fixed": `ActionsRow-module__fixed___Jpne1`,
	"visible": `ActionsRow-module__visible___I1pCp`,
	"invisible": `ActionsRow-module__invisible___wREcW`,
	"col90": `ActionsRow-module__col-90___D1mbb`,
	"colAuto": `ActionsRow-module__col-auto___JGSDw`,
	"medicalTabs": `ActionsRow-module__medical-tabs___VEtMo`,
	"medicalTableNew": `ActionsRow-module__medical-table-new___eRXrx`,
	"noPagination": `ActionsRow-module__no-pagination___Uqlpi`,
	"medicalTableEmpty": `ActionsRow-module__medical-table-empty___Vkq36`,
	"iconBtn": `ActionsRow-module__icon-btn___Vmk1P`,
	"searchIcon": `ActionsRow-module__search-icon___Lp0qC`,
	"disableSelect": `ActionsRow-module__disable-select___Qw6BP`,
	"breakWord": `ActionsRow-module__break-word___VPpnB`,
	"popupClearBtn": `ActionsRow-module__popup-clear-btn___HL7nX`,
	"scrollMB20": `ActionsRow-module__scroll-m-b-20___hA5hp`,
	"button": `ActionsRow-module__button___GYrvy`,
	"loader": `ActionsRow-module__loader___qWtf9`
};
module.exports = ___CSS_LOADER_EXPORT___;
